import styled from 'styled-components';

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
`;

/**
 * A member of the group, on or off.
 *
 * A button rather than a styled div: the chips are the only control on this
 * step, and a div swallows the keyboard entirely - there is no other way to
 * reach them without a mouse.
 */
export const TargetChip = styled.button<{ $on: boolean }>`
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 16px;
  user-select: none;
  transition: ${({ theme }) => theme.transitions.ease200ms};
  background: ${({ theme, $on }) => ($on ? theme.primary : 'transparent')};
  color: ${({ theme, $on }) => ($on ? theme.white : theme.darkGray)};
  border: 1px solid
    ${({ theme, $on }) =>
      $on ? theme.primary : `${theme.darkGray}${theme.transparency.t30}`};

  :hover {
    border-color: ${({ theme }) => theme.primary};
  }
`;

/**
 * Image on top, fields under it, at every width.
 *
 * Beside the fields the image was a 96px thumbnail - too small to tell two
 * screenshots apart, which is the one thing it is there for - and it squeezed
 * the chips into a column of their own on a narrow modal.
 */
export const GroupLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

/** Full width, so the image is wide enough to recognise at a glance. */
export const GroupImageColumn = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

/**
 * Why this group cannot be saved yet, under the picker it is about.
 *
 * On the card rather than only in the toast on Next: with several groups
 * open, a message naming a pair says nothing about which of the three cards
 * to scroll back to.
 */
export const ImageRequiredHint = styled.p`
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.primary};
`;
